// extracted by css-extract-rspack-plugin
export default {"dialog":"PrefixesDialog-module__dialog__pULR2","dialogBody":"PrefixesDialog-module__dialogBody__gav2Z","helpIcon":"PrefixesDialog-module__helpIcon__fqLHr"};